import React from "react";
import { format } from "date-fns";
import { CheckCircle2, XCircle, Clock, Wifi } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

export default function InspectorStatus({ inspectors }) {
  const getConnectionStatus = (inspector) => {
    if (!inspector.dropbox_connected) {
      return { label: "Not connected", color: "bg-slate-100 text-slate-600", icon: XCircle };
    }
    if (inspector.last_sync_at) {
      const lastSync = new Date(inspector.last_sync_at);
      const minutesAgo = (Date.now() - lastSync.getTime()) / 1000 / 60;
      if (minutesAgo < 30) {
        return { label: "Online", color: "bg-emerald-100 text-emerald-700", icon: Wifi };
      }
    }
    return { label: "Idle", color: "bg-amber-100 text-amber-700", icon: Clock };
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100">
        <h3 className="font-semibold text-slate-900">Inspector Status</h3>
      </div>
      <div className="divide-y divide-slate-100">
        {inspectors.length === 0 ? (
          <div className="px-6 py-12 text-center text-slate-500">
            No inspectors added yet
          </div>
        ) : (
          inspectors.slice(0, 6).map((inspector, index) => {
            const status = getConnectionStatus(inspector);
            return (
              <motion.div
                key={inspector.id}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.05 }}
                className="flex items-center gap-4 px-6 py-4 hover:bg-slate-50 transition-colors"
              >
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-slate-200 to-slate-300 flex items-center justify-center text-slate-600 font-medium">
                  {inspector.name?.[0] || "?"}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-slate-900 truncate">{inspector.name}</p>
                  <p className="text-xs text-slate-500 truncate">
                    {inspector.company || inspector.email}
                  </p>
                </div>
                <Badge className={`${status.color} border-0 gap-1`}>
                  <status.icon className="w-3 h-3" />
                  {status.label}
                </Badge>
              </motion.div>
            );
          })
        )}
      </div>
    </div>
  );
}